<template>
  <div class="page-ct">
    <div class="page-header">
      <strong>Admin Overview</strong>
    </div>

    <p class="info">
      Welcome to the administration panel. <br />
      Here you can manage the content of InsightsHub.
    </p>
    <br />

    <ul>
      <li><strong>Products</strong>: configure Apps, Datafeed, Reports, Stories</li>
      <li><strong>Access</strong>: manage InsightsHub Companies and Users.</li>
      <li><strong>Onboarding</strong>: Manage new company onboaording and T&amp;C signing</li>
      <li><strong>Notifications</strong>: manage notifications in InsightsHub.</li>
      <li><strong>Feedback</strong>: See NPS scores</li>
      <li><strong>Reference data</strong>: manage data like "classification", "tags", etc.</li>
      <li><strong>File Manager</strong>: manage files for apps and stories.</li>
      <li><strong>CMS</strong>: manage content in Products, Help and content pages.</li>
      <li><strong>Settings</strong>: manage some general settings for InsightHub.</li>
      <li><strong>Db Tools</strong>: manage Database and check SQL logs.</li>
    </ul>
    <hr />
  </div>
</template>
<script>
export default {
  name: 'AdminOverview',
  props: {
    item: {},
  },
  components: {},
  data: function() {
    return {
      text: 'Hello World!',
      content: '<h1>Some initial content</h1>',
      editor: null,
      show: false,
      params: {
        token: '123456798',
        name: 'avatar',
      },
      headers: {
        smail: '*_~',
      },
      imgDataUrl: '', // the base64 url of created image
    }
  },
  mounted: async function() {},
  methods: {
    toggleShow() {
      this.show = !this.show
    },
  },
}
</script>
<style scoped>
ul {
  list-style: circle;
  padding-left: 48px;
}
.page-header {
  height: 48px !important;
}
.page-ct {
  font-family: Montserrat, Arial, sans-serif, Helvetica !important;
}
</style>
